import Promise from 'bluebird';

// load an image by url
export function loadImageByUrl(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const { src, naturalWidth, naturalHeight } = image || {};
      resolve({ src, width: naturalWidth, height: naturalHeight });
    };
    image.onerror = () => {
      reject(new Error(`Failed to load image, url: ${url}`));
    };
    image.src = url;
  });
}
